module.exports = __webpack_public_path__ + "static/img/20190221021357_393054.1960a3ad.jpg";